import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aead2c6e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\project\\bigBee\\bigbee_backend_ui_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aead2c6e')) {
      api.createRecord('aead2c6e', component.options)
    } else {
      api.reload('aead2c6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aead2c6e", function () {
      api.rerender('aead2c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dictionary/index.vue"
export default component.exports